import {householdAssistApi} from "../api/household-assist";
import type {HouseholdAssistResult} from "../types/household-assist";

class HouseholdAssistService {
  async search(q: string): Promise<HouseholdAssistResult> {
    const {data} = await householdAssistApi.search(q.trim());
    return (data as {data: HouseholdAssistResult}).data;
  }
}

export const householdAssistService = new HouseholdAssistService();
